(() => {
  if (window.DpkWishlist) return;
  const account = document.querySelector('[data-dpk-wishlist-account]')?.dataset.dpkWishlistAccount || '';
  const endpoint = '/apps/kalendarz-adwentowy/api/wishlist';
  let snapshot = {revision: 0, items: []}, csrf = '', loaded = false, loading, queue = Promise.resolve();
  const clean = values => [...new Set(values.filter(x => /^[\p{L}\p{N}][\p{L}\p{N}\p{M}™®-]{0,200}$/u.test(x)))].slice(0,200);
  function guest() { try { return clean((localStorage.getItem('shopify-wishlist') || '').split(',')); } catch { return []; } }
  function handles() { return account ? snapshot.items.map(p => p.handle) : guest(); }
  function changed() { document.dispatchEvent(new CustomEvent('shopify-wishlist:updated', {detail: {wishlist: handles()}})); }
  function message(text) {
    let status = document.getElementById('dpk-wishlist-status');
    if (!status) {
      status = document.createElement('p');status.id = 'dpk-wishlist-status';status.setAttribute('role','status');
      Object.assign(status.style,{position:'fixed',bottom:'24px',left:'50%',transform:'translateX(-50%)',maxWidth:'calc(100% - 32px)',width:'max-content',background:'#211709',color:'#f6f1eb',padding:'16px 24px',borderRadius:'3px',zIndex:'10000'});
      document.body.append(status);
    }
    status.textContent = text;status.hidden = false;
    clearTimeout(message.timer);message.timer = setTimeout(() => {status.hidden = true;},6000);
  }
  async function refresh() {
    if (!account) { loaded = true;return; }
    if (loading) return loading;
    loading = (async () => {
      const response = await fetch(endpoint,{cache:'no-store',credentials:'same-origin',headers:{Accept:'application/json'}});
      if (!response.ok) { loaded = false;throw new Error('Nie udało się pobrać ulubionych z konta. Spróbuj ponownie.'); }
      const data = await response.json();snapshot = data;csrf = data.csrf;loaded = true;
    })();
    try { await loading; } finally { loading = null; }
  }
  async function request(path, data) {
    const response = await fetch(endpoint + path,{method:'POST',cache:'no-store',credentials:'same-origin',headers:{'Content-Type':'application/json','X-Notebook-CSRF':csrf},body:JSON.stringify(data)});
    if (!response.headers.get('content-type')?.includes('application/json')) throw new Error('Nie udało się zapisać ulubionych. Spróbuj ponownie.');
    const result = await response.json();
    if (!response.ok) {
      if (response.status === 409) { await refresh();changed();throw new Error('Lista zmieniła się na innym urządzeniu. Sprawdź ją i ponów swój wybór.'); }
      if (result.error === 'session_expired') {loaded = false;throw new Error('Odśwież stronę i spróbuj ponownie.');}
      throw new Error(result.error === 'wishlist_full' ? 'Na liście może być do 200 produktów.' : 'Nie udało się zapisać ulubionych. Spróbuj ponownie.');
    }
    snapshot = result;changed();return result;
  }
  function serialized(action) {const result = queue.then(action);queue = result.catch(() => {});return result;}
  window.DpkWishlist = {
    account,handles,message,guest,
    async ready(){if(!loaded)await refresh();},
    async refresh(){await refresh();changed();},
    toggle(handle){return serialized(async()=>{
      await this.ready();
      const present = !handles().includes(handle);
      if(account)await request('',{handle,present,revision:snapshot.revision});
      else {
        const next = present ? clean([...guest(),handle]) : guest().filter(h=>h!==handle);
        try {localStorage.setItem('shopify-wishlist',next.join(','));}catch{throw new Error('Przeglądarka nie pozwala zapisać ulubionych.');}
        changed();
      }
      message(present?'Dodano do ulubionych.':'Usunięto z ulubionych.');
    });},
    importGuest(){return serialized(async()=>{
      if(!account)return;await this.ready();const selected=guest();
      const result=await request('/import',{handles:selected,revision:snapshot.revision});
      // Only clear exactly the imported browser version, preserving edits from other tabs.
      if(guest().join(',')===selected.join(','))localStorage.removeItem('shopify-wishlist');
      changed();message(result.missing?.length?'Zapisano dostępne produkty. Części produktów nie ma już w sklepie.':'Zapisano ulubione na Twoim koncie.');
    });}
  };
  window.addEventListener('focus',()=>{if(account)window.DpkWishlist.refresh().catch(()=>{});});
  window.addEventListener('storage',event=>{if(event.key==='shopify-wishlist')changed();});
})();
